export default "/images/video-call.png?4bd53f03e97f0fdcb398d1dd31872be9";